module.exports = __webpack_public_path__ + "img/pc_p3_scene.75c7e5c2.svg";